import { Component, OnInit,Input,NgZone } from '@angular/core';
import { StockFilterService } from 'src/app/features/stock-screener/services/stock-filter.service';
import { ChangeDetectorRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FinancialDataService } from 'src/app/features/stock-screener/services/financial-data.service';
import { lastValueFrom } from 'rxjs';
import { pipe } from 'rxjs';

import { ApiResponse,Hit } from 'src/app/models/sector-industries/sector-industries.model';

@Component({
    selector: 'app-stock-financials',
    templateUrl: './stock-financials.component.html',
    styleUrls: ['./stock-financials.component.scss'],
    standalone: false
})
export class StockFinancialsComponent implements OnInit {
   private destroy$ = new Subject<void>();

   @Input() ticker: string = "";
   period: string[] = ['2020-12', '2021-12', '2022-12', '2023-12', '2024-12'];
   quartPeriod: string[] = ['2024-03', '2024-06', '2024-09','2024-12'];
  financialData: any;  // Or create a proper type for your financial data
  chartData:any;
  chartKey :string = "LOOP"
  //000004.SZ
  epsTTM :number=0;
  cashFlowPerShareAnnual :number=0;
  chartValues: number[] = [];


  //values array
  bookValuesArray:any[]=[]
  tangibleBookValuesArray:any[]=[]

  dividentPerShareArray:any[]=[]
  ebitPerShareArray:any[]=[]
  epsArray:any[]=[]
  revenuePerShare:any[]=[]

  bookValuePerShare:any[]=[]
  tangibleBookValuePerShare:any[]=[]
  epsFwd:any[]=[]
  price_to_earning: any[] = []




  isLoading: boolean = true;
  constructor(private financialService: StockFilterService,
   private cd: ChangeDetectorRef,private financialDataService: FinancialDataService) { }

  ngOnInit(): void {
    //console.log("Ticker received is", this.chartKey);

    Promise.all([
      this.getPerShareValue(this.ticker, this.revenuePerShare, this.epsArray, this.ebitPerShareArray, this.dividentPerShareArray, this.price_to_earning),
      //this.getActualAnnualData("bookValue", "annual", this.bookValuePerShare),
      //this.getActualAnnualData("tangibleBookValue", "annual", this.tangibleBookValuePerShare),
      this.getActualAnnualData("eps", "annual", this.epsFwd),

    ]).then(() => {
      this.isLoading = false; // Set to false when all are completed
      this.cd.detectChanges(); // Update the UI
    }).catch(error => {
      //console.error("Error fetching data", error);
      this.isLoading = false; // Ensure it is set to false even if there's an error
      this.cd.detectChanges();
    });
  }

  async getActualAnnualData(name:string,timePeriod:string, targetArray: any[]) {
     try {
       const ticker = this.ticker;

       // Call the financialService method to fetch chart data (assuming it returns a Promise<ApiResponse>)
       const response=  await this.financialService.getRatAnnualData(ticker, this.period, name, timePeriod);
       //console.log("Annual ratio data is", response);

       // Define the target years
       const targetYears = [2020, 2021, 2022, 2023, 2024];

       targetArray.length = 0; // Clear previous data

       if (response?.hits) {
         // Create a new array to hold the mapped values for each year
         const yearMappedValues: { [year: number]: any | null } = {
           2020: null,
           2021: null,
           2022: null,
           2023: null,
           2024: null,
         };

         // Filter, sort, and map to get the 'v' values by year
         response.hits
           .filter((hit: Hit) => hit?.document?.name === name)
           .forEach((hit: Hit) => {
             const period = new Date(hit?.document?.period);
             const year = period.getFullYear();

             // Only map the data for the years we care about
             if (targetYears.includes(year)) {
               yearMappedValues[year] = hit?.document?.v; // Assign the 'v' value for the corresponding year
             }
           });

         // Push the mapped values for the target years into the targetArray
         targetYears.forEach((year) => {
           targetArray.push(yearMappedValues[year]); // If no data found, it will be null
         });

         //console.log("Updated Annual Values:", targetArray);
         this.cd.detectChanges();
       }
        return targetArray;

     } catch (error) {
       //console.error('Error fetching book share value:', error);
       throw error; // Re-throw the error for further handling
     }
   }
//    async getActualQuarterlyData(name:string,timePeriod:string, targetArray: any[]) {
//     try {
//       const ticker = this.ticker;

//       // Call the financialService method to fetch chart data (assuming it returns a Promise<ApiResponse>)
//       const response = await this.financialService.getRatQuarterlyData(ticker, this.quartPeriod, name, timePeriod);
//       console.log("Quarterly ratio data is",response)

//       targetArray.length = 0;

//       return targetArray;








//     } catch (error) {
//       console.error('Error fetching book share value:', error);
//       throw error; // Re-throw the error for further handling
//     }
//   }
//   async getBookShareValue(name:string,timePeriod:string, targetArray: any[]) {
//     try {
//       const ticker = this.chartKey;

//       // Call the financialService method to fetch chart data (assuming it returns a Promise<ApiResponse>)
//       const response: ApiResponse = await this.financialService.getChartData(ticker, this.period, name, timePeriod);

//       // Check if 'hits' exists
//       if (response?.hits) {
//         // Extract the hits array from the response
//         const hits = response.hits;

//         // Filter records based on specific criteria (e.g., name)
//       const filteredRecords = hits.filter((hit) => hit.document.name === name);

//       // Push the filtered records into the provided target array
//       targetArray.push(...filteredRecords);

//         // Log the updated array to check the result
//       console.log('Updated Array:', targetArray);
//       this.cd.detectChanges();
//       return targetArray;  // Return the updated array if needed
//       } else {
//         throw new Error('No hits found in the response');
//       }
//     } catch (error) {
//       console.error('Error fetching book share value:', error);
//       throw error; // Re-throw the error for further handling
//     }
//   }

async getPerShareValue(name: string, rpsArray: any[], epsArray: any[], ebitArray: any[], dividentArray: any[], price_to_earning2:any[]) {
  try {
    const ticker = name;

    // Fetch the API response
    const response = await this.financialService.perShareData(ticker);

    // Assuming the response is the data object
    const data = response;

    // Define target years in the desired order
    const targetYears = ["2020", "2021", "2022", "2023", "2024"];

    // Clear the arrays before populating them
    dividentArray.length = 0;
    rpsArray.length = 0;
    epsArray.length = 0;
    ebitArray.length = 0;

    // Loop through the target years and extract the 'v' value for each year for all arrays
    targetYears.forEach((year) => {
      // Map dividendPerShareTTM data
      const dividendData = data.dividendPerShareTTM?.[year] ?? null;
      dividentArray.push(dividendData);

      // Map revenue_per_share data
      const rpsData = data.revenue_per_share?.[year] ?? null;
      rpsArray.push(rpsData);

      // Map epsTTM data
      const epsData = data.epsTTM?.[year] ?? null;
      epsArray.push(epsData);

      // Map ebit_per_share data
      const ebitData = data.ebit_per_share?.[year] ?? null;
      ebitArray.push(ebitData);


      const price_to_earning = data.price_to_earning?.[year] ?? null;
      price_to_earning2.push(price_to_earning);
    });

    // Print all arrays after mapping the data
   //  console.log("Mapped Dividend Data (dividentArray):", dividentArray);
   //  console.log("Mapped Revenue Per Share Data (rpsArray):", rpsArray);
   //  console.log("Mapped EPS Data (epsArray):", epsArray);
   //  console.log("Mapped EBIT Per Share Data (ebitArray):", ebitArray);

    this.cd.detectChanges();

    return dividentArray;
  } catch (error) {
    //console.error("Error fetching dividend data:", error);
    throw error; // Re-throw the error for further handling
  }
}




//   async loadFinancialData() {
//    try {
//      const data = await this.financialDataService.fetchFinancialData();
//      console.log('Financial Data:', data);
//    } catch (error) {
//      console.error('Error fetching financial data:', error);
//    }
//  }


//   loadData(ticker: string): void {
//    this.isLoading = true;
//    this.cd.detectChanges();

//    this.financialService.getFinancialData(ticker).subscribe({
//      next: (data) => {
//       console.log("data is",data)
//        this.financialData = data;
//        this.epsTTM = data.epsTTM || 0;
//        this.cashFlowPerShareAnnual = data.cashFlowPerShareAnnual || 0;

//        console.log('Updated values:', {
//          epsTTM: this.epsTTM,
//          cashFlowPerShareAnnual: this.cashFlowPerShareAnnual



//        });

//        this.isLoading = false;
//        this.cd.detectChanges();
//      },
//      error: (error) => {
//        console.error('Error fetching financial data:', error);
//        this.isLoading = false;
//        this.cd.detectChanges();
//      }
//    });
//  }


//  getTangibleBookValue(ticker: string): void {
//    this.isLoading = true;


//    this.financialService.getChartData(ticker, "2019-12-31", "tangibleBookValue", "annual")
//      .pipe(
//        takeUntil(this.destroy$), // Add if you have a destroy subject
//        finalize(() => {
//          this.isLoading = false;

//        })
//      )
//      .subscribe({
//        next: (response) => {
//          // Handle the response here
//          if (response.hits && response.hits.length > 0) {
//            const documentData = response.hits[0].document;
//            console.log('Document data:', documentData);
//            // Process your data here
//          } else {
//            console.log('No data found');
//          }
//        },
//        error: (error) => {
//          console.error('Error fetching financial data:', error);
//        }
//      });
//  }

//   loadChartData(ticker: string): void {  // Explicitly typing the ticker parameter
//    this.financialService.getChartData(ticker).subscribe(
//      (data) => {
//        this.chartData = data;
//        console.log('Financial Data:', data);
//      },
//      (error) => {
//        console.error('Error fetching financial data:', error);
//      }
//    );
//  }

  selectedTab: number = 0;
  selectTab(index: number): void {
    this.selectedTab = index;
  }
}
